<template>
  <div class="footer">
        <!-- <div class="global-footer-lazy">
            <div class="ecsc-service-flow">
                <div class="ecsc-service-item"><i class="ecsc-zp"></i><span>正品保障</span></div>
                <div class="ecsc-service-item"><i class="ecsc-qt"></i><span>七天包退</span></div>
                <div class="ecsc-service-item"><i class="ecsc-hp"></i><span>好评如潮</span></div>
                <div class="ecsc-service-item"><i class="ecsc-sd"></i><span>闪电发货</span></div>
                <div class="ecsc-service-item last"><i class="ecsc-ry"></i><span>权威荣誉</span></div>
            </div>
        </div> -->
        <div class="banxin">
            <div class="top">
                <div class="leftBox">
                    <p class="title">客服电话</p>
                    <p class="number">15601914931</p>
                    <p class="time">09:00-23:00</p>
                    <div class="consult">咨询客服</div>
                </div>
                <div class="centerBox">
                    <p class="title">关注双甲子</p>
                    <p>专注于客单价，转化率提升！</p>
                    <p>便捷高效，助力各大商家提升客单价，</p>
                    <p>客户引导，提高复购，</p>
                    <p>只为更好的服务每一位用户。</p>
                </div>
                <div class="rightBox">
                    <div class="aboutUs">
                        <p class="title">关于我们</p>
                        <p class="cur-poi">了解我们</p>
                        <p class="cur-poi">合作咨询</p>
                        <p class="cur-poi">联系我们</p>
                    </div>
                    <div class="qrCode">
                        <p class="title">下载双甲子商城</p>
                        <img src="../../../static/image/qrcode.png" alt="">
                    </div>
                </div>
            </div>
            <p class="bottom">&copy;Copyright © All rights reversed 上海华郡科技有限公司 沪ICP备2022007834号-3</p>
            <p class="bottom">中华人民共和国增值电信业务经营许可证 经营许可证编号 沪B2-20230426</p>
        </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  }
}
</script>
<style lang = "scss" scoped>
.footer{
    width: 100%;
    height: 450px;
    background-color: #000000;
    opacity: 0.82;
    color: #FFFFFF;
    overflow: hidden;
    .global-footer-lazy{
        width:100%;
        height:86px;
        background:#dddddd;
        .ecsc-service-flow{
            width:1200px;
            height:86px;
            margin:auto;
            position:relative;
        }
    }
    .ecsc-service-item{
        float:left;
        font-size:18px;
        padding:20px 0;
        margin-right:135px;
        color:#000000;
    }
    .ecsc-service-item.last{
        margin-right:0;
        color:#000000;
    }
    .ecsc-service-item i{
        display:block;
        width:45px;
        height:45px;
        background:url(../../../static/image/ecsc_icon.png) no-repeat;
        float:left;
    }
    .ecsc-service-item span{
        display:block;
        float:left;
        padding:15px 0 0 15px;
    }
    .ecsc-service-item .ecsc-zp{
        background-position:-7px -152px;
    }
    .ecsc-service-item .ecsc-qt{
        background-position:-7px -202px;
    }
    .ecsc-service-item .ecsc-hp{
        background-position:-7px -253px;
    }
    .ecsc-service-item .ecsc-sd{
        background-position:-6px -304px;
    }
    .ecsc-service-item .ecsc-ry{
        background-position:-6px -354px;
    }
    .banxin{
        width: 1252px;
        height: 100%;
        margin: 0 auto;
        .top{
            margin-top: 100px;
            display: flex;
            margin-bottom: 38px;
            text-align: center;
            .leftBox{
                flex: 1;
                display: flex;
                flex-direction: column;
                .title{
                    font-size: 16px;
                    margin-bottom: 33px;
                }
                .number{
                    font-size: 40px;
                    margin-bottom: 12px;
                    font-weight: 500;
                }
                .time{
                    font-size: 18px;
                    margin-bottom: 33px;
                }
                .consult{
                    cursor: pointer;
                    margin: 0 auto;
                    width: 220px;
                    height: 36px;
                    line-height: 36px;
                    border: 1px solid #FFFFFF;
                    box-sizing: border-box;
                    opacity: 0.6;
                }
            }
            .centerBox{
                flex: 1;
                border-left: 2px solid rgba($color: #FFFFFF, $alpha: 0.15);
                border-right: 2px solid rgba($color: #FFFFFF, $alpha: 0.15);
                p{
                    font-size: 16px;
                    line-height: 25px;
                }
                .title{
                    margin-bottom: 33px;
                }
            }
            .rightBox{
                flex: 1;
                display: flex;
                .aboutUs{
                    flex: 1;
                    p{
                        margin-bottom: 20px;
                    }
                    .title{
                        margin-bottom: 33px;
                    }
                }
                .qrCode{
                    flex: 1;
                    .title{
                        margin-bottom: 33px;
                    }
                    img{
                        width: 106px;
                        height: 106px;
                    }
                }
            }
        }
        .bottom{
            text-align: center;
            font-size: 15px;
            line-height: 24px;
            color: #eeeee0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/base/footer.vue